// src/components/AdminHeader.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function AdminHeader() {
  const { user, logout } = useAuth();
  if (!user) return null;

  return (
    <div className="w-full border-b border-[#D4FF00]/30 bg-black/70 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center justify-between">
        <span className="text-[#D4FF00] font-bold"><Link to="/admin">RevyTech Admin</Link></span>
        <div className="text-sm text-gray-300 flex items-center gap-3">
          <span>{user.email}</span>
          <button
            className="px-3 py-1.5 rounded bg-[#D4FF00] text-black font-semibold hover:brightness-90 transition"
            onClick={logout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
